<template>
  <el-container>
    <el-header>经销商列表
      <el-divider></el-divider>
    </el-header>
    <el-main>
      <el-button v-if="userRole" size="small" type="primary" @click="handleAddClick">新增</el-button>
      <el-button v-if="userRole" size="small" type="primary" @click="toExcel">导出</el-button>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          width="60">
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="公司名称"
          width="230">
        </el-table-column>
        <el-table-column
          prop="belongArea"
          label="所属大区"
          width="120">
        </el-table-column>
        <el-table-column
          prop="responsibleArea"
          label="负责区域"
          width="120">
        </el-table-column>
        <el-table-column
          prop="contacts1"
          label="联系人1"
          width="160">
        </el-table-column>
        <el-table-column
          prop="contacts2"
          label="联系人2"
          width="160">
        </el-table-column>
        <el-table-column
          prop="companyPhone"
          label="公司电话"
          width="130">
        </el-table-column>
        <el-table-column
          min-width="180"
          prop="companyAddress"
          label="公司地址">
        </el-table-column>


        <el-table-column
          v-if="userRole"
          fixed="right"
          label="操作"
          :width="handleWidth">
          <template slot-scope="scope">

            <el-button @click="handleUpdate(scope.row)" type="text" size="small"
                       style="margin-bottom: 1px;padding: 1px">编辑
            </el-button>
            <el-button @click="open(scope.row)" type="text" size="small"
                       style="margin-bottom: 1px;padding: 1px">删除
            </el-button>
            <el-button v-if="!scope.row.username" @click="handleAddAccountClick(scope.row)" type="text" size="small"
                       style="margin-bottom: 1px;padding: 1px">分配账号
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--修改信息 表单-->
      <el-dialog title="修改经销商信息" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" :label-position="labelPosition">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请填写客户公司全称" disabled></el-input>
          </el-form-item>
          <el-form-item label="所属大区" prop="belongArea">
            <el-input v-model="form.belongArea" placeholder="请填写公司所属区域"></el-input>
          </el-form-item>
          <el-form-item label="负责区域" prop="responsibleArea">
            <el-input v-model="form.responsibleArea" placeholder="请填写负责区域"></el-input>
          </el-form-item>
          <el-form-item label="联系人1" prop="contacts1">
            <el-input v-model="form.contacts1" placeholder="请填写联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系人2" prop="contacts2">
            <el-input v-model="form.contacts2" placeholder="请填写联系人"></el-input>
          </el-form-item>
          <el-form-item label="公司电话" prop="companyPhone">
            <el-input v-model="form.companyPhone" placeholder="请填写公司电话"></el-input>
          </el-form-item>
          <el-form-item label="公司地址" prop="companyAddress">
            <el-input v-model="form.companyAddress" placeholder="请填写公司地址"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
          <el-button size="medium" type="primary" @click="handleSubmit('form')">提 交</el-button>
        </div>
      </el-dialog>

      <!--分配账号 表单-->
      <el-dialog title="分配账号" :visible.sync="accountFormVisible" width="400px">
        <el-form ref="accountForm" :model="accountForm" :rules="accountRules" label-width="120px"
                 v-loading="loadingGen">
          <el-form-item label="账号用户名" prop="username">
            <el-input v-model="accountForm.username" placeholder="请填写账号用户名"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="accountFormVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="handleGenerateClick('accountForm')">生 成</el-button>
        </div>
      </el-dialog>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dealerCount">
        </el-pagination>
      </div>
      <div class="pagination2">
        <el-pagination
          small
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="size"
          layout=" total,prev, pager, next"
          :total="dealerCount">
        </el-pagination>
      </div>
    </el-main>

  </el-container>
</template>

<script>
export default {
  name: "Dealer",
  data() {
    return {
      labelPosition: 'right',
      handleWidth: 92,
      tableData: [],
      dealerCount: 0,
      currentPage: 1,
      size: 10,
      user: '',
      form: {},
      accountForm: {
        username: '',
        belongDealer: ''
      },
      dialogFormVisible: false,
      accountFormVisible: false,
      rules: {
        companyName: [
          {required: true, message: '请输入公司名称', trigger: 'blur'},
        ],
        belongArea: [
          {required: true, message: '请输入公司所属大区', trigger: 'blur'},
        ],
        responsibleArea: [
          {required: true, message: '请输入负责区域', trigger: 'blur'},
        ],
        contacts1: [
          {required: true, message: '请输入联系人', trigger: 'blur'},
        ],
        companyPhone: [
          {required: true, message: '请输入公司电话', trigger: 'blur'},
        ],
        companyAddress: [
          {required: true, message: '请输入公司地址', trigger: 'blur'},
        ],
      },
      accountRules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
        ]
      },
      loading: false,
      loadingGen: false,
      userRole: false
    }
  },
  methods: {
    handleSizeChange(val) {
      this.size = val;
      this.loadDealer(this.currentPage, this.size);
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadDealer(this.currentPage, this.size);
      // console.log(`当前页: ${val}`);
    },
    count() {
      this.$http.get("https://yuanteng.tech:8081/dealer/findCount").then(res => {
        this.dealerCount = res.data;
      })
    },
    loadDealer(page, size) {
      this.loading = true
      page = page == 1 ? 1 : this.currentPage;   //当前页
      size = size == 10 ? 10 : this.size;        //每页多少条
      this.$http.get("https://yuanteng.tech:8081/dealer/find?currentPage=" + page + "&sizePage=" + size).then(res => {
        this.tableData = res.data;
      }).finally(() => {
        this.loading = false
      });
    },
    //删除客户信息
    handleDelete(row) {
      this.loading = true
      this.$http.get("https://yuanteng.tech:8081/dealer/delete?id=" + row.id).then(res => {
        if (res.data.status) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
          this.loadDealer();
          this.count()
        } else {
          this.$message.error(res.data.msg);
        }
      }).finally(() => {
        this.loading = false
      })
    },
    //删除 操作确认弹出框
    open(row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(row);
      }).catch(() => {
        const h = this.$createElement;
        this.$message({
          type: 'info',
          message: h('p', {style: 'width:120px '}, '已取消删除')
          // message: ''
        });
      });
    },

    //修改用户信息
    handleUpdate(row) {
      this.dialogFormVisible = true;
      this.loadDealer();
      this.form = row;
    },
    handleSubmit(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          this.$http.post("https://yuanteng.tech:8081/dealer/update", this.form).then(res => {
            if (res.data.status) {
              this.$message({
                message: res.data.msg,
                type: 'success'
              });

            } else {
              this.$message.error(res.data.msg);
            }
          }).finally(() => {
            this.loading = false
            this.count();
            this.loadDealer();
          });
        }
      });
    },
    //新增经销商
    handleAddClick() {
      this.$router.push('/index/addDealer');
    },
    //新增账号
    handleAddAccountClick(row) {
      this.accountForm = {};
      this.accountForm.belongDealer = row.companyName;
      this.accountFormVisible = true;
    },
    handleGenerateClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingGen = true
          this.$http.post("https://yuanteng.tech:8081/user/save", this.accountForm).then(response => {
            if (response.data.status) {
              this.$message({
                type: 'success',
                message: response.data.msg
              })
              this.accountFormVisible = false;
              this.accountForm = {};
              this.count();
              this.loadDealer();
            } else {
              this.$message.error(response.data.msg);
            }
          }).finally(() => {
            this.loadingGen = false;
          });
        }
      })
    },
    handleResize() {
      if (window.innerWidth < 768) {
        this.labelPosition = "top";
        this.handleWidth = 60;
      } else {
        this.labelPosition = 'right';
        this.handleWidth = 92;
      }
    },
    /**
     * 导出所有经销商信息及其账号
     */
    toExcel() {
      window.open("https://yuanteng.tech:8081/dealer/export?token=" + this.user.token);
    }
  },
  created() {
    this.user = JSON.parse(window.localStorage.getItem('access-admin')) || {};
    this.userRole = decodeURIComponent(window.atob(this.user.role)) == "ADMIN"
    this.loadDealer();
    this.count();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>

.el-main {
  padding-top: 10px;
  margin-bottom: 20px;
}

.el-button {
  margin-bottom: 15px;
}

.el-divider {
  margin-bottom: 2px;
}

/deep/ .el-dialog {
  width: 50%;
}

.el-input {
  max-width: 340px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.pagination2 {
  margin-top: 20px;
  text-align: right;
  display: none;
}


@media screen {
  /deep/ .el-form--label-top .el-form-item__label {
    padding: 0 !important;
  }
}

@media screen and (max-width: 768px) {
  .pagination {
    display: none;
  }

  .pagination2 {
    display: block;
  }

  /deep/ .el-form-item {
    margin-bottom: 8px;
  }

  /deep/ .el-dialog {
    width: 70% !important;
  }

  .el-form {
    max-width: 300px;
  }

  /deep/ .el-button + .el-button, .el-checkbox.is-bordered + .el-checkbox.is-borderedn {
    margin-left: 0 !important;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Dealer.vue